import { useEffect, useState } from 'react';
import { useWatch } from 'react-hook-form';
import InputDecorator from '@enerex/unified-ui-react/form/InputDecorator';
import LoadingButton from '@enerex/unified-ui-react/LoadingButton';
import Select from 'components/UnifiedSelect';
import { getStates } from 'pages/utilities/utilityApi';
import { getStateOptionValue, getStateDisplayName } from 'pages/utilities/utilityUtils';

const ZoneStateField = ({ control, setValue, disabled }) => {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [attempt, setAttempt] = useState(0);
    const stateName = useWatch({ control, name: 'stateName' });
    useEffect(() => {
        let current = true;
        setLoading(true); setError('');
        getStates().then(states => {
            if (current) setOptions(states.map(state => ({ value: Number(getStateOptionValue(state)), label: getStateDisplayName(state) }))
                .filter(option => Number.isInteger(option.value) && option.value > 0 && option.label));
        }).catch(() => { if (current) setError('Unable to load states. Please retry.'); })
            .finally(() => { if (current) setLoading(false); });
        return () => { current = false; };
    }, [attempt]);
    return <div>
        <InputDecorator name="stateId" control={control} label="State *"
            rules={{ validate: value => (Number.isInteger(Number(value)) && Number(value) > 0) || 'Select a state.' }}
            render={({ field: input, fieldState }) => <Select className="settings-lookup__form-select" inputId="zone-state" aria-label="State"
                options={options} isLoading={loading} isDisabled={disabled || loading || Boolean(error)} invalid={fieldState.invalid}
                value={options.find(option => option.value === Number(input.value)) || (input.value ? { value: Number(input.value), label: stateName || 'Current state' } : null)}
                onChange={option => { input.onChange(option?.value || ''); setValue('stateName', option?.label || '', { shouldDirty: true }); }}
                onBlur={input.onBlur} placeholder="Select state" isClearable={false} />} />
        {error && <><p role="alert">{error}</p><LoadingButton type="button" onClick={() => setAttempt(value => value + 1)}>Retry states</LoadingButton></>}
    </div>;
};
export default ZoneStateField;
